import type { GameType } from '@big2/shared';
import type { InfoPageType } from '../InfoPages.js';
import { useI18n } from '../../i18n.js';

export interface LandingFooterProps {
  onScrollToLauncher: (targetGame?: GameType) => void;
  onOpenRules?: (gameType: GameType) => void;
  onOpenInfoPage?: (page: InfoPageType) => void;
}

export function LandingFooter({ onScrollToLauncher, onOpenRules, onOpenInfoPage }: LandingFooterProps) {
  const { lang, t } = useI18n();
  const isMn = lang === 'mn';

  return (
    <footer className="landing-footer" aria-label={isMn ? 'Хөл хэсэг' : 'Footer'}>
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <span>🃏</span>
            <span>arvangurav.com</span>
          </div>
          <p className="footer-tagline">{t.landingFooterBrandText}</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">{isMn ? 'Үндсэн & Нэмэлт Тоглоом' : 'Games & Rules'}</h4>
          <a
            href="/big2"
            onClick={(e) => {
              e.preventDefault();
              onScrollToLauncher('big2');
            }}
          >
            ♠ {isMn ? 'Арван гурав — Үндсэн' : 'Big Two (Main Game)'}
          </a>
          <a
            href="/rules/big2"
            onClick={(e) => {
              if (onOpenRules) {
                e.preventDefault();
                onOpenRules('big2');
              }
            }}
          >
            {isMn ? 'Арван гурав дүрэм' : 'Big Two Rules'}
          </a>
          <a
            href="/muushig"
            onClick={(e) => {
              e.preventDefault();
              onScrollToLauncher('muushig');
            }}
          >
            {isMn ? 'Муушиг' : 'Muushig'}
          </a>
          <a
            href="/daaluu"
            onClick={(e) => {
              e.preventDefault();
              onScrollToLauncher('daaluu');
            }}
          >
            {isMn ? 'Даалуу' : 'Daaluu'}
          </a>
          <a
            href="/rules/muushig"
            onClick={(e) => {
              if (onOpenRules) {
                e.preventDefault();
                onOpenRules('muushig');
              }
            }}
          >
            {isMn ? 'Муушиг дүрэм' : 'Muushig Rules'}
          </a>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">{isMn ? 'Мэдээлэл & Нөхцөл' : 'Info & Policies'}</h4>
          <a
            href="/subscription"
            onClick={(e) => {
              if (onOpenInfoPage) {
                e.preventDefault();
                onOpenInfoPage('subscription');
              }
            }}
          >
            {isMn ? 'VIP Гишүүнчлэл' : 'VIP Benefits'}
          </a>
          <a
            href="/terms"
            onClick={(e) => {
              if (onOpenInfoPage) {
                e.preventDefault();
                onOpenInfoPage('terms');
              }
            }}
          >
            {isMn ? 'Үйлчилгээний нөхцөл' : 'Terms of Service'}
          </a>
          <a
            href="/privacy"
            onClick={(e) => {
              if (onOpenInfoPage) {
                e.preventDefault();
                onOpenInfoPage('privacy');
              }
            }}
          >
            {isMn ? 'Нууцлалын бодлого' : 'Privacy Policy'}
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">{t.landingFooterCopyright}</p>
        <div className="footer-tools">
          <span> arvangurav.com </span>
        </div>
      </div>
    </footer>
  );
}
